import { getFirebaseAuthService, getFunctionsService } from './krida-auth.js';
import { httpsCallable } from "https://www.gstatic.com/firebasejs/10.12.2/firebase-functions.js";

let joinGameModalElement;
let closeJoinGameModalBtn;
let refreshJoinableGamesBtn;
let invitedGamesListDiv; // Re-enabled
let openGamesListDiv;

function assignJoinGameModalElements() {
    joinGameModalElement = document.getElementById('join-game-modal');
    if (joinGameModalElement) {
        closeJoinGameModalBtn = joinGameModalElement.querySelector('#close-join-game-modal-btn');
        refreshJoinableGamesBtn = joinGameModalElement.querySelector('#refresh-joinable-games-btn');
        invitedGamesListDiv = joinGameModalElement.querySelector('#invited-games-list'); // Re-enabled
        openGamesListDiv = joinGameModalElement.querySelector('#open-games-list');

        if (closeJoinGameModalBtn) {
            closeJoinGameModalBtn.addEventListener('click', () => closeJoinGameModal());
        }
        if (refreshJoinableGamesBtn) {
            refreshJoinableGamesBtn.addEventListener('click', () => fetchAndDisplayJoinableGames(true));
        }
    } else {
        console.warn("Join Game Modal elements not found on this page.");
    }
}

async function fetchAndDisplayJoinableGames(isRefresh = false) {
    console.log("fetchAndDisplayJoinableGames CALLED. isRefresh:", isRefresh);
    if (!invitedGamesListDiv || !openGamesListDiv) {
        console.warn("fetchAndDisplayJoinableGames: List divs not found. Aborting.");
        return;
    }

    invitedGamesListDiv.innerHTML = '<p class="loading-text">Loading invited games...</p>';
    openGamesListDiv.innerHTML = '<p class="loading-text">Loading open games...</p>';

    try {
        const functions = getFunctionsService();
        if (!functions) {
            console.error("fetchAndDisplayJoinableGames: Firebase Functions service not available.");
            invitedGamesListDiv.innerHTML = '<p class="error-text">Error: Could not connect to service.</p>';
            openGamesListDiv.innerHTML = '<p class="error-text">Error: Could not connect to service.</p>';
            return;
        }
        const getMyGamesCallable = httpsCallable(functions, 'getMyGamesCallable');
        console.log("fetchAndDisplayJoinableGames: Calling 'getMyGamesCallable' Cloud Function...");
        const result = await getMyGamesCallable(); 
        const gamesData = result.data;

        console.log("fetchAndDisplayJoinableGames: Received data from 'getMyGamesCallable':", JSON.stringify(gamesData, null, 2));

        if (gamesData) {
            console.log("Invited Games received:", gamesData.invitedGames ? gamesData.invitedGames.length : 0);
            console.log("Open Games received:", gamesData.openGames ? gamesData.openGames.length : 0);
            displayGames(invitedGamesListDiv, gamesData.invitedGames || [], 'No games you\'ve been invited to yet.');
            displayGames(openGamesListDiv, gamesData.openGames || [], 'No open public games available right now.');
        } else {
            console.warn("fetchAndDisplayJoinableGames: No data received from cloud function or data is empty.");
            invitedGamesListDiv.innerHTML = '<p>No invited games found or error loading.</p>';
            openGamesListDiv.innerHTML = '<p>No open games found or error loading.</p>';
        }
    } catch (error) {
        console.error("Error fetching joinable games:", error);
        invitedGamesListDiv.innerHTML = '<p class="error-text">Failed to load invited games. Please try again.</p>';
        openGamesListDiv.innerHTML = '<p class="error-text">Failed to load open games. Please try again.</p>';
    }
}

function displayGames(container, games, emptyMessage) {
    if (!container) return;

    // Defensive check: Ensure games is an array. If not, treat as empty or log error.
    if (!Array.isArray(games)) {
        console.warn("displayGames: received 'games' parameter that is not an array. Treating as empty. Value:", games);
        games = []; // Default to an empty array
    }

    if (games.length === 0) {
        container.innerHTML = `<p>${emptyMessage}</p>`;
        return;
    }

    const ul = document.createElement('ul');
    ul.className = 'joinable-games-list'; // Add a class for styling if needed
    games.forEach(game => {
        const li = document.createElement('li');
        li.style.display = 'flex'; // Use flexbox for alignment
        li.style.justifyContent = 'space-between'; // Space out text and button
        li.style.alignItems = 'center'; // Vertically center items
        li.style.marginBottom = '8px'; // Add some space between list items

        const textContainer = document.createElement('div');
        
        const creatorName = game.player1DisplayName || 'Player';
        let displayDate = 'Date N/A';
        if (game.createdAt) {
            try {
                const date = new Date(game.createdAt);
                displayDate = date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) + ' ' + 
                              date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
            } catch (e) {
                console.warn("Could not parse game.createdAt:", game.createdAt, e);
            }
        }

        // Create separate elements for name and date for styling
        const nameElement = document.createElement('div');
        nameElement.textContent = `Game by ${creatorName}`;
        const dateElement = document.createElement('div');
        dateElement.textContent = `Created: ${displayDate}`;
        dateElement.style.fontSize = '0.9em'; // Slightly smaller font for date
        dateElement.style.color = '#666'; // Grey color for date

        textContainer.appendChild(nameElement);
        textContainer.appendChild(dateElement);

        const joinButton = document.createElement('button');
        joinButton.className = 'btn btn-primary btn-small join-game-item-btn';
        joinButton.textContent = 'Join';
        joinButton.dataset.gameId = game.gameId || '';

        if (game.gameId) {
            joinButton.addEventListener('click', async (event) => {
                const button = event.currentTarget;
                button.disabled = true;
                button.textContent = 'Joining...';
                try {
                    await handleJoinGameAction(game.gameId);
                    // On success, the user is redirected, so no need to re-enable the button.
                } catch (error) {
                    // On failure, re-enable the button so the user can try again.
                    button.disabled = false;
                    button.textContent = 'Join';
                    // The error is already logged and alerted inside handleJoinGameAction
                }
            });
        } else {
            joinButton.disabled = true;
            joinButton.title = "Cannot join: Game ID is missing";
            joinButton.addEventListener('click', () => {
                 console.error("Cannot join game: game ID is missing.");
                 alert("Cannot join game: ID is missing.");
            });
        }
        
        li.appendChild(textContainer);
        li.appendChild(joinButton);
        ul.appendChild(li);
    });
    container.innerHTML = ''; // Clear previous content
    container.appendChild(ul);
}

async function handleJoinGameAction(gameId) {
    const auth = getFirebaseAuthService();
    if (!auth || !auth.currentUser) {
        alert("Please sign in to join a game.");
        return;
    }
    const functions = getFunctionsService();
    if (!functions) {
        alert("Cannot connect to game services.");
        return;
    }

    console.log(`Attempting to join game: ${gameId}`);
    try {
        const joinGameFunction = httpsCallable(functions, 'joinGameCallable');
        const result = await joinGameFunction({ gameId: gameId });
        if (result.data && result.data.success) {
            // alert("Successfully joined game! Redirecting..."); // Reducing alerts for better UX
            window.location.href = `/krida.html?gameId=${gameId}`;
        } else {
            throw new Error(result.data?.message || "Failed to join game for an unknown reason.");
        }
    } catch (error) {
        console.error("Error joining game:", error);
        alert(`Could not join game: ${error.message}`);
        throw error; // Re-throw the error so the calling function knows about the failure
    }
}

export function openJoinGameModal() {
    if (!joinGameModalElement) {
        console.error("Join Game Modal element not found. Was initJoinGameModal called?");
        return;
    }
    joinGameModalElement.style.display = 'block';
    fetchAndDisplayJoinableGames(); // Fetch games when modal is opened
}

function closeJoinGameModal() {
    if (joinGameModalElement) {
        joinGameModalElement.style.display = 'none';
    }
}

export function initJoinGameModal() {
    const modalContainer = document.getElementById('joinGameModalContainer');
    if (!modalContainer) {
        console.error("Join Game Modal container not found in HTML.");
        return Promise.reject("Join Game Modal container missing");
    }

    return fetch('/join-game-modal.html')
        .then(response => {
            if (!response.ok) throw new Error(`Failed to load join-game-modal.html: ${response.statusText}`);
            return response.text();
        })
        .then(html => {
            modalContainer.innerHTML = html;
            assignJoinGameModalElements();

            if (!joinGameModalElement) {
                console.error("Join Game Modal main element not found after loading HTML.");
                return;
            }

            // Add event listener for background click to close
            joinGameModalElement.addEventListener('click', (event) => {
                if (event.target === joinGameModalElement) {
                    closeJoinGameModal();
                }
            });

            console.log("Join Game Modal initialized and listeners attached.");
        })
        .catch(error => {
            console.error('Error initializing Join Game Modal:', error);
            if (modalContainer) modalContainer.innerHTML = '<p>Error loading tool to join games. Please try again later.</p>';
        });
} 